import type { ReactNode } from 'react';

export interface Column<T> {
  header: string;
  cell: (row: T) => ReactNode;
  align?: 'left' | 'right';
}

export function Table<T>({ columns, rows, emptyLabel = 'Keine Daten' }: { columns: Column<T>[]; rows: T[]; emptyLabel?: string }) {
  if (rows.length === 0) {
    return <p className="py-8 text-center text-sm text-slate-400">{emptyLabel}</p>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-slate-200 text-left text-slate-500 dark:border-slate-800 dark:text-slate-400">
            {columns.map((col) => (
              <th key={col.header} className={`py-2 pr-4 font-medium ${col.align === 'right' ? 'text-right' : ''}`}>
                {col.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100 dark:divide-slate-800/60">
          {rows.map((row, i) => (
            <tr key={i} className="text-slate-700 dark:text-slate-300">
              {columns.map((col) => (
                <td key={col.header} className={`py-2 pr-4 ${col.align === 'right' ? 'text-right' : ''}`}>
                  {col.cell(row)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
